var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 9.10613 9.10613 10 8 10C6.89387 10 6 9.10613 6 8C6 6.89387 6.89387 6 8 6C9.10613 6 10 6.89387 10 8Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9188 9.11579L13.918 9.11678C12.4053 11.1254 10.264 12.25 8.00001 12.25C5.73599 12.25 3.59474 11.1254 2.08198 9.11678L2.08123 9.11579C1.87663 8.84505 1.75 8.44222 1.75 8.00001C1.75 7.55779 1.87663 7.15495 2.08124 6.88419L2.08198 6.88321C3.59473 4.87459 5.73598 3.75 8.00001 3.75C10.264 3.75 12.4053 4.87458 13.918 6.88321L13.9188 6.88419C14.1234 7.15495 14.25 7.55779 14.25 8.00001C14.25 8.44222 14.1234 8.84505 13.9188 9.11579Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
};
export default SvgEye;